import "./EntryHub.css";
import Orbit2 from "./Orbit2";

// ONAM look: the hub renders in place (src/onam/hub); the old slide-in and page tint belonged to the atom diagram
const EntryHub = ({ authContext }) => {
  return <Orbit2 authContext={authContext} />;
};

export default EntryHub;
